module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"summary":{"total":"{1}の未入金注文が{0}件","description":"あります。","hint":"（ {0} 時点 ）"},"order":{"code":"注文番号：{0}","created_at":"注文日：{0}","bank_account":"{0} {1} {2}","sender_name":"（振込名義人：{0}）","copy_bank_account_no":"口座番号をコピー"}}}')
  delete Component.options._Ctor
}
